/**
 * 日本語翻訳ファイル
 * MIBiGデータベースフロントエンド用
 */
export const ja = {
  // ========================================
  // ナビゲーション
  // ========================================
  nav: {
    home: "ホーム",
    clusters: "クラスター",
    genes: "遺伝子",
    proteins: "タンパク質",
    blast: "BLAST検索",
    reactions: "反応検索",
    substructure: "部分構造検索",
    fujisan: "FUJISAN",
    unkai: "UNKAI",
  },

  // ========================================
  // ホームページ
  // ========================================
  home: {
    title: "MIBiGデータベース",
    version: "BGC Proteins データベース v3.0",
    heroTitle: "生合成遺伝子クラスター",
    heroSubtitle: "データベース＆エクスプローラー",
    heroDescription: "高度な検索、3Dタンパク質可視化、化学構造解析を備えた、生合成遺伝子クラスターの包括的リポジトリを探索できます。",
    browseBtn: "クラスターを閲覧",
    blastBtn: "BLAST検索",
    statsTitle: "データベース統計",
    featuresTitle: "機能を探索",
    quickSearch: "クイック検索",
    quickSearchDesc: "キーボードショートカット",
    quickSearchKey: "Ctrl+K",
    quickSearchHelp: "でコマンドパレットを開き、すばやく移動できます。",
    openPalette: "コマンドパレットを開く",
  },

  // ========================================
  // 統計カード
  // ========================================
  stats: {
    clusters: "遺伝子クラスター",
    genes: "遺伝子",
    structures: "タンパク質構造",
    compounds: "化合物",
  },

  // ========================================
  // 機能カード
  // ========================================
  features: {
    clusterBrowser: {
      title: "クラスターブラウザ",
      description: "高度なフィルタリングで生合成遺伝子クラスターを閲覧・検索",
    },
    blastSearch: {
      title: "BLAST検索",
      description: "PDBとSwissProtデータベースに対して配列を検索",
    },
    reactionSearch: {
      title: "反応検索",
      description: "Rheaデータベースを使用して酵素反応を検索",
    },
    substructureSearch: {
      title: "部分構造検索",
      description: "化学構造の類似性で化合物を検索",
    },
    explore: "探索",
  },

  // ========================================
  // クラスターページ
  // ========================================
  cluster: {
    title: "クラスター一覧",
    filterBy: "フィルター",
    biosynClass: "生合成クラス",
    organism: "生物種",
    allClasses: "すべてのクラス",
    allOrganisms: "すべての生物種",
    search: "検索...",
    mibigAccession: "MIBiGアクセッション",
    organismName: "生物種名",
    mainProduct: "主生産物",
    geneCount: "遺伝子数",
    compounds: "化合物",
    ncbiTaxId: "NCBI Taxonomy ID",
    mibigVersion: "MIBiGバージョン",
    noResults: "条件に一致するクラスターが見つかりません。",
    loading: "クラスターを読み込み中...",
  },

  // ========================================
  // 遺伝子ページ
  // ========================================
  gene: {
    title: "遺伝子一覧",
    inCluster: "クラスター内の遺伝子",
    product: "製品",
    proteinId: "タンパク質ID",
    uniprotLink: "UniProtリンク",
    pdbHits: "PDBヒット",
    swissprotHits: "SwissProtヒット",
    domains: "ドメイン",
    sites: "サイト",
    viewProtein: "タンパク質を表示",
  },

  // ========================================
  // タンパク質ページ
  // ========================================
  protein: {
    title: "タンパク質詳細",
    structure: "予測構造",
    domains: "保存ドメイン",
    sites: "機能部位",
    pdbHits: "PDB BLASTヒット",
    swissprotHits: "SwissProt BLASTヒット",
    sequence: "配列",
    sequenceLength: "配列長",
  },

  // ========================================
  // 構造ビューワー
  // ========================================
  structure: {
    selectModel: "モデルを選択",
    alphafold: "AlphaFold",
    colabfold: "ColabFold",
    colorBy: "着色モード",
    colorPlDDT: "plDDTで着色",
    colorSecondary: "二次構造で着色",
    colorAminoAcid: "アミノ酸で着色",
    wholeStructure: "全体構造",
    highlightDomain: "ドメインをハイライト",
    highlightSite: "サイトをハイライト",
    downloadPdb: "PDBをダウンロード",
  },

  // ========================================
  // ドメイン・サイト
  // ========================================
  domain: {
    pssmId: "PSSM ID",
    accession: "アクセッション",
    shortName: "短縮名",
    description: "説明",
    residueRange: "残基範囲",
    evalue: "E値",
    siteType: "サイトタイプ",
    residues: "残基",
    sourceDomain: "ソースドメイン",
  },

  // ========================================
  // BLASTヒットテーブル
  // ========================================
  blast: {
    title: "BLAST検索",
    querySequence: "クエリ配列",
    database: "データベース",
    submit: "検索実行",
    results: "検索結果",
    hit: "ヒット",
    hsp: "HSP",
    pdbId: "PDB ID",
    chainId: "チェーン",
    title_col: "タイトル",
    evalue: "E値",
    identity: "同一性",
    coverage: "カバー率",
    accession: "アクセッション",
    recname: "推奨名",
    ligands: "リガンド",
    reactions: "反応",
    dbMibig: "MIBiG",
    dbPdb: "PDB",
    dbSwissprot: "SwissProt",
    dbCdd: "CDD",
  },

  // ========================================
  // 反応検索
  // ========================================
  reaction: {
    title: "反応検索",
    searchByCompound: "化合物名で検索",
    searchPlaceholder: "化合物名を入力...",
    rheaId: "Rhea ID",
    equation: "反応式",
    substrates: "基質",
    products: "生成物",
    ecNumber: "EC番号",
    kegg: "KEGG",
    participants: "反応関与物質",
  },

  // ========================================
  // 部分構造検索
  // ========================================
  substructure: {
    title: "部分構造検索",
    smartsPattern: "SMARTSパターン",
    smartsPlaceholder: "SMARTSパターンを入力...",
    examples: "例:",
    benzene: "ベンゼン環",
    search: "検索",
    results: "検索結果",
    matchingCompounds: "一致する化合物",
  },

  // ========================================
  // ChEBIテーブル
  // ========================================
  chebi: {
    chebiId: "ChEBI ID",
    count: "件数",
    bestEvalue: "最良E値",
    name: "名前",
    formula: "分子式",
    pubchem: "PubChem",
    structure: "構造",
  },

  // ========================================
  // タブラベル
  // ========================================
  tabs: {
    swissprotEntries: "SwissProtエントリー",
    reactionParticipants: "反応関与物質",
    pdbEntries: "PDBエントリー",
    boundLigands: "結合リガンド",
  },

  // ========================================
  // 共通UI
  // ========================================
  common: {
    loading: "読み込み中...",
    error: "エラーが発生しました",
    noData: "データがありません",
    notFound: "見つかりませんでした",
    search: "検索",
    submit: "実行",
    reset: "リセット",
    back: "戻る",
    next: "次へ",
    previous: "前へ",
    showMore: "もっと見る",
    showLess: "閉じる",
    download: "ダウンロード",
    copy: "コピー",
    copied: "コピーしました",
    externalLink: "外部リンク",
    viewDetails: "詳細を表示",
    topResults: "上位 {count} 件",
    page: "ページ",
    of: "/",
    items: "件",
  },

  // ========================================
  // エラーメッセージ
  // ========================================
  errors: {
    fetchFailed: "データの取得に失敗しました",
    notFound: "リソースが見つかりません",
    serverError: "サーバーエラーが発生しました",
    networkError: "ネットワークエラーが発生しました",
    invalidInput: "入力が無効です",
    timeout: "リクエストがタイムアウトしました",
    // ApiErrorコンポーネント用の新しいエラーメッセージ
    unknown: "予期しないエラーが発生しました",
    error: "エラー",
    network: "ネットワークエラー",
    server: "サーバーエラー",
    checkConnection: "インターネット接続を確認して、もう一度お試しください。",
    tryAgain: "問題が発生しました。もう一度お試しください。",
    tryAgainLater: "サーバーに問題が発生しています。しばらくしてからお試しください。",
    resourceNotFound: "リクエストされたリソースが見つかりませんでした。",
  },

  // ========================================
  // パンくずナビ
  // ========================================
  breadcrumbs: {
    home: "ホーム",
    clusters: "クラスター",
    genes: "遺伝子",
    proteins: "タンパク質",
    blast: "BLAST",
    reactions: "反応",
    substructure: "部分構造",
  },

  // ========================================
  // フッター
  // ========================================
  footer: {
    copyright: "© 2024 MIBiGデータベース",
    dataSources: "データソース",
    contact: "お問い合わせ",
  },

  // ========================================
  // データソース
  // ========================================
  dataSources: {
    mibig: "MIBiG（天然物生合成遺伝子クラスター）",
    uniprot: "UniProt（タンパク質配列・機能データベース）",
    rhea: "Rhea（生化学反応データベース）",
    chebi: "ChEBI（化学物質オントロジー）",
    pdb: "PDB（タンパク質構造データベース）",
    pubchem: "PubChem（化学物質データベース）",
    alphafold: "AlphaFold（タンパク質構造予測）",
    ncbiBlast: "NCBI BLAST+",
    cdd: "CDD（保存ドメインデータベース）",
  },

  // ========================================
  // 生合成クラス
  // ========================================
  biosynClasses: {
    NRPS: "非リボソームペプチド合成酵素",
    PKS: "ポリケチド合成酵素",
    Terpene: "テルペン",
    RiPP: "リボソーム合成・翻訳後修飾ペプチド",
    Saccharide: "糖質",
    Alkaloid: "アルカロイド",
    Other: "その他",
  },

  // ========================================
  // クラスター詳細ページ
  // ========================================
  clusterDetail: {
    backToBrowser: "ブラウザに戻る",
    backToClusterBrowser: "クラスターブラウザに戻る",
    clusterNotFound: "クラスターが見つかりません",
    viewOnMibig: "MIBiGで表示",
    exportData: "データをエクスポート",
    clusterInformation: "クラスター情報",
    biosyntheticClass: "生合成クラス",
    ncbiTaxonomyId: "NCBI Taxonomy ID",
    mibigVersion: "MIBiGバージョン",
    geneCount: "遺伝子数",
    genes: "遺伝子",
    compounds: "化合物",
    noCompoundsRecorded: "化合物情報なし",
    viewDetails: "詳細を表示",
    noDescription: "説明なし",
    domains: "ドメイン",
    pdb: "PDB",
    swissprot: "SwissProt",
    fujisan: "FUJISAN",
    unkai: "UNKAI",
    noGenesFound: "このクラスターには遺伝子が見つかりません",
    proteinInteractionNetwork: "タンパク質相互作用ネットワーク",
    interactions: "相互作用",
    clickNodeDescription: "タンパク質ノードをクリックして詳細を表示。エッジをクリックして複合体予測を表示。",
    showInteractionTable: "相互作用テーブルを表示",
    hideInteractionTable: "相互作用テーブルを非表示",
    type: "タイプ",
    protein1: "タンパク質1",
    protein2: "タンパク質2",
    ipSAE: "ipSAE",
    ipSAE_min: "ipSAE_min",
    ipTM: "ipTM",
    homo: "ホモ",
    hetero: "ヘテロ",
    alphafold2Description: "AlphaFold2マルチマーによるタンパク質間相互作用予測。ipTM ≥ 0.6の相互作用のみ表示。",
  },

  // ========================================
  // タンパク質ビューアーページ
  // ========================================
  proteinViewer: {
    proteinNotFound: "タンパク質が見つかりません",
    backToCluster: "クラスター{accession}に戻る",
    aminoAcids: "アミノ酸",
    ncbiProtein: "NCBIタンパク質",
    uniprot: "UniProt",
    downloadPdb: "PDBをダウンロード",
    structure3d: "3D構造",
    loadingStructure: "構造を読み込み中...",
    noStructureAvailable: "構造データがありません",
    blastHits: "BLASTヒット",
    pdbHits: "PDBヒット",
    swissprotHits: "SwissProtヒット",
    sequence: "配列",
    copy: "コピー",
    copied: "コピーしました",
    noSequenceAvailable: "配列データがありません",
    conservedDomains: "保存ドメイン",
    pssmId: "PSSM ID",
    accession: "アクセッション",
    shortName: "短縮名",
    residueRange: "残基範囲",
    evalue: "E値",
    domainPositions: "配列上のドメイン位置",
    functionalSites: "機能部位",
    siteType: "サイトタイプ",
    residues: "残基",
    sourceDomain: "ソースドメイン",
    downloadCoordinates: "座標をダウンロード",
    models: "モデル",
    alphafold: "AlphaFold",
    colabfold: "ColabFold",
  },

  // ========================================
  // 複合体詳細ページ
  // ========================================
  complexDetail: {
    failedToLoadComplex: "複合体データの読み込みに失敗しました",
    backToCluster: "クラスターに戻る",
    proteinComplexPrediction: "タンパク質複合体予測",
    predictedInteraction: "{protein1}と{protein2}間の予測相互作用",
    predictionScores: "予測スコア",
    ipTM: "ipTM",
    ipTMDescription: "界面予測TMスコア（高いほど信頼性が高い）",
    ipSAE: "ipSAE",
    ipSAEDescription: "界面ペアワイズアライメントエラースコア",
    ipSAE_min: "ipSAE_min",
    ipSAE_minDescription: "最小界面ペアワイズアライメントエラー",
    interactionType: "相互作用タイプ",
    homodimer: "ホモダイマー",
    heterodimer: "ヘテロダイマー",
    interactingProteins: "相互作用タンパク質",
    protein1: "タンパク質1",
    protein2: "タンパク質2",
    viewProteinDetails: "タンパク質詳細を表示",
    complexStructure: "複合体構造",
    downloadPdb: "PDBをダウンロード",
    chainA: "チェーンA ({protein})",
    chainB: "チェーンB ({protein})",
    noStructureAvailable: "複合体構造座標はまだ利用できません。",
    structureWillBeDisplayed: "予測された複合体モデルは利用可能になり次第ここに表示されます。",
    noComplexDataFound: "このタンパク質ペアの複合体データが見つかりません。",
  },

  // ========================================
  // BLAST検索ページ
  // ========================================
  blastSearch: {
    title: "BLAST検索",
    description: "MIBiG、PDB、SwissProt、CDDデータベースに対してタンパク質配列を検索",
    submitSequence: "配列を送信",
    proteinSequence: "タンパク質配列（FASTA形式）",
    loadExample: "例を読み込む",
    placeholder: "FASTA形式でタンパク質配列を貼り付け...",
    targetDatabase: "対象データベース",
    expectThreshold: "期待値（E値）",
    maxTargetSequences: "最大ターゲット配列数",
    notApplicableForCdd: "CDD検索には適用されません",
    runBlastSearch: "BLAST検索を実行",
    searchResults: "検索結果",
    runningBlastSearch: "BLAST検索を実行中...",
    mayTakeMinutes: "データベースのサイズによって数分かかる場合があります。",
    searchFailed: "検索に失敗しました",
    unexpectedError: "予期しないエラーが発生しました。もう一度お試しください。",
    foundHits: "{database}データベースで{count}件のヒットが見つかりました",
    noSignificantHits: "有意なヒットが見つかりません。E値の閾値を調整してみてください。",
    mibigVsPdb: "MIBiG vs PDB (BLAST)",
    mibigVsSwissprot: "MIBiG vs SwissProt (BLAST)",
    rank: "#",
    mibig: "MIBiG",
    protein: "タンパク質",
    product: "製品",
    evalue: "E値",
    identity: "同一性",
    coverage: "カバー率",
    pdbId: "PDB ID",
    chain: "チェーン",
    title_col: "タイトル",
    ligands: "リガンド",
    name: "名前",
    ecNumbers: "EC番号",
    bitscore: "ビットスコア",
    range: "範囲",
    domainArchitecture: "ドメインアーキテクチャ",
  },

  // ========================================
  // 反応検索ページ
  // ========================================
  reactionSearch: {
    title: "反応検索",
    description: "反応参加物質を検索して関連するMIBiG遺伝子クラスターを見つける",
    searchReactionParticipants: "反応参加物質を検索",
    placeholder: "化合物名で検索（例：ATP、NADH、アセチルCoA）...",
    examples: "例：",
    compounds: "化合物",
    chebiCompounds: "ChEBI化合物",
    found: "件発見",
    structure: "構造",
    chebiId: "ChEBI ID",
    formula: "分子式",
    noCompoundsFound: "「{term}」に一致する化合物が見つかりません",
    reactionsInvolving: "に関連する反応",
    reactions: "反応",
    back: "戻る",
    viewProteins: "タンパク質を表示",
    noReactionsFound: "この化合物の反応が見つかりません。",
    mibigProteinsFor: "のMIBiGタンパク質",
    proteins: "タンパク質",
    reaction: "反応：",
    organism: "生物種",
    noProteinsFound: "この反応のタンパク質が見つかりません。",
    aboutReactionSearch: "反応検索について",
    aboutDescription: "このツールでは、反応参加物質（ChEBI化合物）からRhea反応を経て、これらの反応を触媒するMIBiG遺伝子クラスタータンパク質へとナビゲートできます。",
    navigationFlow: "ナビゲーションフロー：",
    step1: "化合物名で検索（例：「ATP」）",
    step2: "化合物を選択して関連反応を表示",
    step3: "反応を選択して触媒するMIBiGタンパク質を表示",
  },

  // ========================================
  // 部分構造検索ページ
  // ========================================
  substructureSearch: {
    title: "部分構造検索",
    description: "SMARTSパターンを使用して特定の化学部分構造を含むChEBI化合物を検索",
    searchBySmartsExpression: "SMARTS式で検索",
    smartsPattern: "SMARTSパターン",
    placeholder: "SMARTSパターンを入力（例：c1ccccc1 はベンゼン環）",
    commonPatterns: "一般的なパターン：",
    searchSubstructures: "部分構造を検索",
    searching: "一致する化合物を検索中...",
    mayTakeMoment: "複雑なパターンの場合、少し時間がかかることがあります。",
    searchFailed: "検索に失敗しました",
    invalidSmartsPattern: "無効なSMARTSパターンです。式を確認してください。",
    matchingCompounds: "一致する化合物",
    compoundsFound: "件の化合物が見つかりました",
    noCompoundsFound: "SMARTSパターンに一致する化合物が見つかりません。より単純または一般的な部分構造をお試しください。",
    rheaReactions: "Rhea反応",
    mibigHits: "MIBiGヒット",
    pageOf: "ページ {page} / {totalPages}（全{total}件）",
    previous: "前へ",
    next: "次へ",
    aboutSmartsSearch: "SMARTS部分構造検索について",
    aboutDescription: "このツールはRDKitライブラリを使用して、指定された部分構造を含むChEBI化合物を検索します。結果はRhea反応アノテーションを通じてMIBiG生合成遺伝子クラスターにリンクされています。",
    smartsPatternExamples: "SMARTSパターン例：",
    benzeneRing: "ベンゼン環",
    carboxylicAcid: "カルボン酸",
    sixMemberedRing: "6員炭素環",
    primaryAmine: "第一級アミン",
  },

  // ========================================
  // PDBヒットページ
  // ========================================
  pdbHitsPage: {
    backTo: "{protein}に戻る",
    pdbBlastHits: "PDB BLASTヒット",
    domain: "ドメイン {start}-{end}",
    fromCluster: "クラスターより",
    hitsFound: "PDBヒット発見",
    pdbEntries: "PDBエントリー",
    boundLigands: "結合リガンド",
    rank: "#",
    pdbId: "PDB ID",
    chain: "チェーン",
    title: "タイトル",
    evalue: "E値",
    identity: "同一性",
    coverage: "カバー率",
    structure: "構造",
    ligandId: "リガンドID",
    name: "名前",
    formula: "分子式",
    pdb: "PDB",
    pubchem: "PubChem",
    noBoundLigands: "PDBヒットに結合リガンドが見つかりません",
  },

  // ========================================
  // SwissProtヒットページ
  // ========================================
  swissprotHitsPage: {
    failedToLoad: "SwissProtヒットの読み込みに失敗しました",
    backToProtein: "タンパク質に戻る",
    swissprotBlastHits: "SwissProt BLASTヒット",
    domain: "ドメイン {start}-{end}",
    fromCluster: "クラスターより",
    hitsFound: "SwissProtヒット発見",
    filteredByReaction: "反応でフィルター: {rheaAccession}",
    swissprotEntries: "SwissProtエントリー",
    reactions: "反応",
    rank: "#",
    accession: "アクセッション",
    name: "名前",
    evalue: "E値",
    identity: "同一性",
    coverage: "カバー率",
    ecNumbers: "EC番号",
    kegg: "KEGG",
    cofactors: "補因子",
    noSwissprotHits: "SwissProtヒットが見つかりません",
    rheaId: "Rhea ID",
    equation: "反応式",
    swissprot: "SwissProt",
    noReactionsFound: "SwissProtヒットに反応が見つかりません",
    chebiCompounds: "ChEBI化合物",
  },

  // ========================================
  // データソースページ
  // ========================================
  dataSourcesPage: {
    title: "データソース",
    description: "このアプリケーションで使用されているデータベースとリソースに関する情報",
    mibigVersion: "遺伝子クラスター情報はMIBiGバージョン4.0に基づいています",
    lastUpdated: "最終更新：2024年11月15日",
    externalDatabases: "外部データベース",
    visit: "アクセス",
    download: "ダウンロード",
    precomputedBlast: "事前計算されたBLAST結果",
    precomputedDescription: "このデータベースのすべてのBLAST結果は事前に計算され、高速な検索のために保存されています。以下のデータセットが利用可能です：",
    rows: "行",
    bulkDownloads: "一括ダウンロード",
    bulkDescription: "このデータベースに保存されているBLAST検索結果は、タブ区切り値（TSV）形式でダウンロードできます。",
    searchAndBrowse: "検索とブラウズオプション",
    byMibigAccession: "MIBiGアクセッション番号で",
    byMibigAccessionDesc: "MIBiGアクセッション番号（例：BGC0000001）を使用して遺伝子クラスターを検索",
    byProteinId: "タンパク質IDで",
    byProteinIdDesc: "NCBIタンパク質識別子または遺伝子座タグで遺伝子を検索",
    byCompoundName: "化合物名で",
    byCompoundNameDesc: "ワイルドカードサポート付きで化合物名により反応参加物質を検索",
    bySubstructure: "部分構造で",
    bySubstructureDesc: "SMARTS式を使用して部分構造マッチングで化合物を検索",
    blastSearch: "BLAST検索",
    blastSearchDesc: "カスタム配列でMIBiG、PDB、SwissProt、CDDデータベースを検索",
    browseClusters: "クラスターを閲覧",
    browseClustersDesc: "生合成クラスと生物種でフィルターして全遺伝子クラスターを閲覧",
    developedBy: "開発者",
    affiliation1: "東京大学 大学院農学生命科学研究科 応用生命工学専攻 計算生物学研究室",
    affiliation2: "東京科学大学 医歯学総合研究科 計算創薬デザイン研究室",
    affiliation3: "山梨大学 大学院総合研究部 機械工学（メカトロニクス）",
  },

  // ========================================
  // 404ページ
  // ========================================
  notFoundPage: {
    title: "404",
    heading: "ページが見つかりません",
    description: "お探しのページは存在しないか、移動されました。URLを確認するか、ホームページに戻ってください。",
    goBack: "戻る",
    home: "ホーム",
  },

  // ========================================
  // コマンドパレット
  // ========================================
  commandPalette: {
    placeholder: "クラスター、タンパク質、配列、化合物を検索...",
    quickNavigation: "クイックナビゲーション",
    recentlyVisited: "最近訪問",
    recentSearches: "最近の検索",
    actions: "アクション",
    compounds: "化合物",
    pages: "ページ",
    clusters: "クラスター",
    proteins: "タンパク質",
    searching: "検索中...",
    noResults: "「{query}」の結果が見つかりません",
    typeToSearch: "検索するには2文字以上入力してください",
    navigate: "移動",
    select: "選択",
    close: "閉じる",
    sequenceDetected: "配列を検出 - BLAST検索を実行",
    smartsDetected: "SMARTSパターンを検出 - 化学構造を検索",
    compoundDetected: "化合物/酵素を検出 - 反応を検索",
    mibigAccessionDetected: "MIBiGアクセッションを検出",
    searchClustersProteins: "クラスターとタンパク質を検索",
    goToHomepage: "ホームページへ移動",
    browseAllClusters: "全遺伝子クラスターを閲覧",
    sequenceSimilaritySearch: "配列類似性検索",
    searchBiochemicalReactions: "生化学反応を検索",
    chemicalSubstructureSearch: "化学部分構造検索",
    recentSearch: "最近の検索",
    searchCompoundsReactions: "化合物と生化学反応を検索",
  },

  // ========================================
  // 相互作用ネットワーク
  // ========================================
  interactionNetwork: {
    noInteractionsFound: "タンパク質相互作用が見つかりません",
    zoomIn: "拡大",
    zoomOut: "縮小",
    fitToView: "全体表示",
    proteinClickToView: "タンパク質（クリックで詳細表示）",
    ipTMHigh: "ipTM ≥ 0.9（高）",
    ipTMMedium: "ipTM 0.75-0.9",
    ipTMLow: "ipTM 0.6-0.75",
    edgeLabelsShowIpTM: "エッジラベルはipTM値を表示",
    clickEdgeForDetails: "エッジをクリックで複合体詳細",
  },

  // ========================================
  // ヘッダー
  // ========================================
  header: {
    database: "データベース",
    toggleLanguage: "言語を切り替え",
    toggleTheme: "テーマを切り替え",
  },

  // ========================================
  // フッター（拡張）
  // ========================================
  footerExtended: {
    developedBy: "開発者",
    universityOfTokyo: "東京大学",
    instituteOfScienceTokyo: "東京科学大学",
    universityOfYamanashi: "山梨大学",
    dataSources: "データソース：MIBiG v4.0（2024年11月）、SwissProt 2024_06、AlphaFold v4、Rhea 136",
    viewAllDataSources: "全データソースを表示",
  },
};

export type Translations = typeof ja;
